module.exports = __webpack_public_path__ + "static/media/chart-areaspline.b358b894.svg";